import { RiskReadiness } from "@/components/site/RiskReadiness";
import { Mission } from "@/components/site/Mission";
import { Credentials } from "@/components/site/Credentials";
import { TrackRecord } from "@/components/site/TrackRecord";
import { LivedIt } from "@/components/site/LivedIt";
import { Community } from "@/components/site/Community";
import { Process } from "@/components/site/Process";
import { Services } from "@/components/site/Services";
import { OperationsReview } from "@/components/site/OperationsReview";
import { Attorneys } from "@/components/site/Attorneys";
import { ClaimsEducation } from "@/components/site/ClaimsEducation";
import { Subrogation } from "@/components/site/Subrogation";
import { FloridaUpdates } from "@/components/site/FloridaUpdates";
import { PartnerNetwork } from "@/components/site/PartnerNetwork";
import { PartnerApply } from "@/components/site/PartnerApply";
import { FinalCTA } from "@/components/site/FinalCTA";

// Light internal page shell — same visual language as the topic (Claims & Reports) pages.
const InnerPage = ({ id, eyebrow, title, lede, children }) => (
  <div className="btr-page-enter btr-light bg-white text-[#111114]" data-testid={`page-${id}`}>
    <section className="relative pt-32 pb-12 sm:pt-40 sm:pb-16 overflow-hidden bg-gradient-to-b from-[#f7f7f5] via-white to-white">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(162,2,11,0.08),transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-6">
        <span className="text-[11px] font-display font-extrabold tracking-[0.3em] uppercase text-[#a2020b]">{eyebrow}</span>
        <h1 className="font-display font-extrabold text-[#111114] text-4xl sm:text-5xl lg:text-6xl mt-5 tracking-tight leading-[1]" data-testid="page-title">{title}</h1>
        {lede && <p className="font-body text-zinc-700 text-base sm:text-xl mt-6 leading-relaxed max-w-2xl">{lede}</p>}
      </div>
    </section>
    {children}
  </div>
);

const red = (t) => <span className="text-[#a2020b]">{t}</span>;

export const RiskScorePage = () => (
  <InnerPage id="risk-score" eyebrow="Assessment" title={<>Risk Readiness {red("Score")}</>} lede="A fast, confidential self-assessment of how prepared your property and records are before a loss.">
    <RiskReadiness />
  </InnerPage>
);

export const AboutPage = () => (
  <InnerPage id="about" eyebrow="About Before The Risk" title={<>Before the loss. Before the litigation. {red("Before the risk.")}</>} lede="Our mission, methodology, and the experience behind every engagement.">
    <Mission />
    <Credentials />
    <TrackRecord />
    <LivedIt />
    <Community />
    <Process />
  </InnerPage>
);

export const ServicesPage = () => (
  <InnerPage id="services" eyebrow="What We Do" title={<>Our {red("Services")}</>} lede="Every service links to a dedicated page with its full scope, documentation, and benefits.">
    <Services />
    <OperationsReview />
    <Attorneys />
  </InnerPage>
);

export const InsightsPage = () => (
  <InnerPage id="insights" eyebrow="Insights" title={<>Risk {red("Insights")}</>} lede="Claims education, recovery strategy, and Florida updates for owners, boards, and counsel.">
    <ClaimsEducation />
    <Subrogation />
    <FloridaUpdates />
  </InnerPage>
);

export const PartnersPage = () => (
  <InnerPage id="partners" eyebrow="Partner Network" title={<>Trusted Partner {red("Network")}</>} lede="Work alongside a team that documents before the risk.">
    <PartnerNetwork showCta={false} />
    <PartnerApply />
  </InnerPage>
);

export const ContactPage = () => (
  <InnerPage id="contact" eyebrow="Contact" title={<>Schedule a {red("Consultation")}</>} lede="Tell us about your property or matter. Every inquiry is handled confidentially.">
    <FinalCTA />
  </InnerPage>
);
